module.exports = __webpack_public_path__ + "static/img/cxm_logo.1745385299907.png";